import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { toast } from '~/web_components/utils/toast';
export const NOTIFICATION_TOASTER_NAME = 'notification-toaster';
let NotificationModule = class NotificationModule extends Vue {
    add(notification) {
        toast(notification.text, notification.type, Object.assign({}, notification.options || {}, 
        // override target because the NotificationModule should always use the same toaster
        {
            target: NOTIFICATION_TOASTER_NAME
        }));
    }
    remove(notification) {
        console.warn('Use removeById instead of remove to dismiss notifications.');
    }
    removeById(id) {
        toast.dismiss(id, NOTIFICATION_TOASTER_NAME);
    }
    clear() {
        toast.clear(NOTIFICATION_TOASTER_NAME);
    }
};
NotificationModule = __decorate([
    Component
], NotificationModule);
export default NotificationModule;
